import { render, staticRenderFns } from "./charge-by-oauth-form.vue?vue&type=template&id=3cfbe5ea&scoped=true&"
import script from "./charge-by-oauth-form.vue?vue&type=script&lang=js&"
export * from "./charge-by-oauth-form.vue?vue&type=script&lang=js&"
import style0 from "./charge-by-oauth-form.vue?vue&type=style&index=0&id=3cfbe5ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfbe5ea",
  null
  
)

export default component.exports